import React from "react";
import { Form, Button, InputGroup, FormControl } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SECTION_RULES, SECTION_NAME_MAX, getRulesForRegion, getSectionRule } from "../../../lib/bands/bandModel";

// Top of a section's tab: where it prints, its height and whether it grows
// with its content. `band` is null while the template is still in the
// four-section format; then only "Grows with its content" shows, and ticking
// it switches the template to bands behind the scenes.
export default function SectionSettings({
  band,
  region,
  isCustom,
  canMoveUp,
  canMoveDown,
  onChange,
  onRuleChange,
  onGrowsChange,
  onMove,
  onRemove,
}) {
  const grows = (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id={`grows-${band ? band.id : "section"}`}
        checked={!!band?.canGrow}
        onChange={(e) => onGrowsChange(e.target.checked)}
      />
      <label
        className="form-check-label"
        htmlFor={`grows-${band ? band.id : "section"}`}
        title="Longer data (addresses, notes) pushes what's below it down, and fields set to 'Hide when empty' close up."
      >
        Grows with its content
      </label>
    </div>
  );

  if (!band) {
    return <div className="section-settings border-bottom pb-3 mb-3">{grows}</div>;
  }

  const rule = getSectionRule(band, region);

  return (
    <div className="section-settings border-bottom pb-3 mb-3">
      {isCustom && (
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold">Section name</Form.Label>
          <FormControl size="sm" value={band.name || ""} placeholder="Section" maxLength={SECTION_NAME_MAX} onChange={(e) => onChange({ name: e.target.value })} />
        </Form.Group>
      )}

      <Form.Group className="mb-2">
        <Form.Label className="fw-bold">Prints</Form.Label>
        <select className="form-select form-select-sm" value={rule} onChange={(e) => onRuleChange(e.target.value)}>
          {getRulesForRegion(region).map((key) => (
            <option key={key} value={key}>{SECTION_RULES[key].label}</option>
          ))}
        </select>
        <Form.Text className="text-muted">
          {region === "top" ? "Sections above the items print at the top of the page." : "Sections below the items print after them or at the bottom of the page."}
        </Form.Text>
      </Form.Group>

      <div className="d-flex align-items-end mb-2" style={{ gap: "12px" }}>
        <Form.Group style={{ width: "120px" }}>
          <Form.Label className="mb-1">Height</Form.Label>
          <InputGroup size="sm" style={{ flexWrap: "nowrap" }}>
            <FormControl
              type="number"
              min="10"
              value={Math.round(band.height)}
              onChange={(e) => {
                const height = parseFloat(e.target.value);
                if (height >= 10) onChange({ height });
              }}
            />
            <InputGroup.Text>px</InputGroup.Text>
          </InputGroup>
        </Form.Group>
        <div className="mb-1">{grows}</div>
      </div>

      <div className="d-flex align-items-center" style={{ gap: "6px" }}>
        <span className="small text-muted me-auto">Order on the page</span>
        <Button size="sm" variant="outline-secondary" title="Move up" disabled={!canMoveUp} onClick={() => onMove(-1)}>
          <FontAwesomeIcon icon="arrow-up" />
        </Button>
        <Button size="sm" variant="outline-secondary" title="Move down" disabled={!canMoveDown} onClick={() => onMove(1)}>
          <FontAwesomeIcon icon="arrow-down" />
        </Button>
        {isCustom && (
          <Button size="sm" variant="outline-danger" title="Remove this section and its content" onClick={onRemove}>
            <FontAwesomeIcon icon="trash" className="me-1" />
            Remove
          </Button>
        )}
      </div>
    </div>
  );
}
